import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// @ts-expect-error error
import { FpsBankSDK } from '@beep/fps-bank-sdk';
import { QRCodeStorage } from "../initializeQRCode/QRCode";
import { SBPBanks } from "./data";
export var initializeSBPBanks = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _QRCodeStorage$getIns, url, fpsSdk, banksList;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _QRCodeStorage$getIns = QRCodeStorage.getInstance().getData(), url = _QRCodeStorage$getIns.url;
          fpsSdk = new FpsBankSDK();
          _context.next = 4;
          return fpsSdk.getBankList(url);
        case 4:
          banksList = _context.sent;
          if (banksList) {
            _context.next = 9;
            break;
          }
          _context.next = 8;
          return SBPBanks.getInstance().initialize([]);
        case 8:
          throw new Error('Cannot fetch Banks List');
        case 9:
          _context.next = 11;
          return SBPBanks.getInstance().initialize(banksList);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function initializeSBPBanks() {
    return _ref.apply(this, arguments);
  };
}();